import { render, staticRenderFns } from "./GuidancePopup.vue?vue&type=template&id=376d928a&scoped=true"
import script from "./GuidancePopup.vue?vue&type=script&lang=js"
export * from "./GuidancePopup.vue?vue&type=script&lang=js"
import style0 from "./GuidancePopup.vue?vue&type=style&index=0&id=376d928a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376d928a",
  null
  
)

export default component.exports